import Login from '../../views/Auth/login/Login';
import { connect } from 'react-redux';

const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(null, mapDispatchToProps)(Login);
